// /connect: sign in to a product for an agent from the link it sent.
// Thin composer: the page lives in features/connections/ConnectTicket.tsx.
import { ConnectTicket } from "@/features/connections/ConnectTicket";

export function ConnectTicketPage() {
  return <ConnectTicket />;
}
